import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from '../static/Crunch Time Jobs.png';
import background from '../static/login_background.jpg';
import '../static/user.css';
import { url } from "../Components/url";
import { Spinner } from "react-bootstrap";

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            setIsLoading(true);
            const response = await fetch(`${url}/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email: email.trim() }),
            });
            const data = await response.json().catch(() => ({}));
            if (response.ok) {
                setMessage(data.message || 'If an account exists with this email, you will receive a reset link.');
            } else {
                setError(data.message || 'Something went wrong.');
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-background">
                <img src={background} alt="Background" />
            </div>
            <div className="login-content">
                <div className="login-card">
                    <div className="login-header">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <h1 className="login-title">Forgot password</h1>
                        <p className="login-subtitle">Enter your email to receive a reset link</p>
                    </div>
                    <form onSubmit={handleSubmit} className="login-body">
                        <div className="login-form-group">
                            <label htmlFor="email" className="login-form-label">Email</label>
                            <input
                                type="email"
                                id="email"
                                className="login-form-control"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        {message && (
                            <div className="alert alert-success mt-2" style={{ fontSize: '0.875rem' }}>
                                {message}
                            </div>
                        )}
                        {error && (
                            <div className="login-error d-flex align-items-center mt-2 text-danger" style={{ fontSize: '0.875rem' }}>
                                {error}
                            </div>
                        )}
                        <button type="submit" className="btn btn-primary mt-3" style={{ width: '100%', padding: '0.75rem' }}>
                            {isLoading ? <Spinner animation="border" size="sm" /> : 'Send reset link'}
                        </button>
                        <p className="mt-3 text-center">
                            <Link to="/" className="login-link">Back to sign in</Link>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
